/**
 * @generated SignedSource<<65ac014b1cd27d9e17f200a6015dafbd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserEventsUpcomingSection_user$data = {
  readonly id: string;
  readonly upcomingEvents: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"EventList_eventsConnection">;
  };
  readonly " $fragmentType": "UserEventsUpcomingSection_user";
};
export type UserEventsUpcomingSection_user$key = {
  readonly " $data"?: UserEventsUpcomingSection_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserEventsUpcomingSection_user">;
};

import UserEventsUpcomingSectionPaginationQuery_graphql from './UserEventsUpcomingSectionPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "upcomingEvents"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": 3,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": UserEventsUpcomingSectionPaginationQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "UserEventsUpcomingSection_user",
  "selections": [
    {
      "alias": "upcomingEvents",
      "args": [
        {
          "kind": "Literal",
          "name": "timeSelection",
          "value": "UPCOMING"
        }
      ],
      "concreteType": "EventsConnection",
      "kind": "LinkedField",
      "name": "__UserEventsUpcomingSection_user_upcomingEvents_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Event",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EventList_eventsConnection"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "__UserEventsUpcomingSection_user_upcomingEvents_connection(timeSelection:\"UPCOMING\")"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "edb8ac8e4e842f9d5757ae44a30def3b";

export default node;
